import { CmsMarketingPreferencesForm } from '../cms/cms-marketing-preferences-form.interface';
import { MarketingPreferencesFormValue } from './marketing-preferences-form-value.type';

export interface MarketingPreferencesFormConfig {
  cmsData: CmsMarketingPreferencesForm;
  initialValue?: MarketingPreferencesFormValue;
}
